import React, { useState, useEffect, useMemo } from "react";
import DyDataGridCustom from '../../../../components/GlobalComponents/DYCustom/DYCustomm';
import {Grid, Box,Typography, Tooltip,Button,IconButton} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from "react-redux";
import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import { useDeleteCooperateRequest, useGetAllCooperateRequestByTeamId,useCheckd} from "../../Hooks";
import AddCooperateRequest from "../../Forms/AddCooperateRequest/AddCooperateRequest";
import EditCooperateRequest from "../../Forms/EditCooperateRequest/EditCooperateRequest";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {GridDeleteIcon} from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';

const CooperateRequest = ({periodId,teamId,keyResultId} : any) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {data:dataIndex,isLoading:dataLoading,isError:dataError,refetch:getAgain}=useGetAllCooperateRequestByTeamId(periodId,teamId,keyResultId);
  const {data:check}=useCheckd(teamId,keyResultId);
  const{mutate:deleteTeam,isError,isSuccess,data:deleteData}=useDeleteCooperateRequest();
  const{data,metaData} : any = dataIndex  || {};
  const{appStatusCode}=metaData  || {};
  const [addEvalAsyncData, setAddEvalAsyncData] = useState<any>(null);
  const [SuccessState, setSuccessState] = useState<boolean>(true);
  const [indexSelectionModel, setIndexSelectionModel] = useState<string | any>(
    localStorage.getItem("indexSelectionModel")
  );

  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );

  
// useEffect(() => {
//   if (deleteData) {
//     if (deleteData?.data.isSuccess) {
//       // setSuccessAddObjective(isSuccess)
//       setShowToastMessage(true);
//       SetIsSuccess(true);
//       SetTMessage(deleteData?.data.metaData.message);
//     } else {
//       setShowToastMessage(true);
//       SetIsSuccess(false);
//       SetTMessage(deleteData?.data.metaData.message);
//       // setAddObjError(deleteData?.data);
//     }
//   }
//  }, [deleteData]);

  useEffect(() => {
    if (addEvalAsyncData) {
      setSuccessState(true);
    }
  }, [addEvalAsyncData]);

  useEffect(() => {
    const indexSelectionModel = localStorage.getItem("indexSelectionModel");
    if (indexSelectionModel) {
      setIndexSelectionModel(indexSelectionModel);
    }
  }, [addEvalAsyncData]);


  const tenantsColumns: any = useMemo(()=>[
    {
      field: "rowid",
      headerName: "ردیف",
      width: 60,
      sortable: false,
      align:'center',
      headerAlign:'center',
      renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
    },
    { field: 'description',
      align:'center',
      headerName: 'شرح درخواست',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
      width: 170,
      flex:1,
      renderCell: ({ value }: { value: string }) => ( // نوع value مشخص شده است
        <Box>
          {value.length > 200 ? (
            <Tooltip title={value}>
              <Typography sx={{ fontSize: "12px" }}>{value.slice(0, 40)}...</Typography>
            </Tooltip>
          ) : (
            <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
          )}
        </Box>)
    },
    { field: 'personIds',
      align:'center',
      headerName: 'همکار دریافت کننده درخواست',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
      width: 170,
      flex:1,
      renderCell: ({ value }: { value: string }) => ( // نوع value مشخص شده است
        <Box>
          {value.length > 50 ? (
            <Tooltip title={value}>
              <Typography sx={{ fontSize: "12px" }}>{value.slice(0, 20)}...</Typography>
            </Tooltip>
          ) : (
            <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
          )}
        </Box>)
    },
      // { field: 'teamName',
      //   align:'center',
      //   headerName: 'درخواست از تیم',
      //   headerAlign:'center',
      //   sortable:false,
      //   wrap:'wrap',
      //   width: 170,
      //   flex:1,
      //   renderCell: ({ value }: { value: string }) => ( // نوع value مشخص شده است
      //     <Box>
      //       {value.length > 20 ? (
      //         <Tooltip title={value}>
      //           <Typography sx={{ fontSize: "12px" }}>{value.slice(0, 20)}...</Typography>
      //         </Tooltip>
      //       ) : (
      //         <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
      //       )}
      //     </Box>)
      // },
      { field: 'requestPriority',
        align:'center',
        headerName: 'اولویت درخواست',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
        width: 170,
        flex:1
      },
      {
        field: "delete",
        headerName: "",
        align: "center",
        headerAlign: "center",
        sortable: false,
        maxWidth: 5,
        fontsize: "10px",
        renderCell: ( par : any) => {
          let idd: string = par?.row?.id;
          return (
            <Box display={"flex"} justifyContent={"center"}>
              {/* <Tooltip  title="ویرایش">
            <IconButton onClick={()=>{
                  initialDelete(idd);
              }}   >
              <GridDeleteIcon />
            </IconButton>
          </Tooltip> */}
          <Button
                sx={{
                  fontSize: "10px",
                  marginRight: "5px",
                  bgcolor: 'white',    // پس‌زمینه سفید
                  color: 'red',    // متن قرمز
                }}
                variant="text"
                startIcon={<GridDeleteIcon />}
                onClick={() => {
                  initialDelete(idd);
                }}
          >
          </Button>
         </Box>
          )
        },
      },
      {
        field: "edit",
        headerName: "",
        align: "center",
        headerAlign: "center",
        sortable: false,
        maxWidth: 5,
        fontsize: "10px",
        renderCell: ( par : any) => {
          let idd: string = par?.row?.id;
          return (
          <Box display={"flex"} justifyContent={"center"}>
          <Tooltip  title="ویرایش">
            <IconButton onClick={()=>{
                  setHistoryModal(true);
                  setKrId(idd);
              }}   >
              <EditIcon color='primary'   />
            </IconButton>
          </Tooltip>
          </Box>
          )
        },
      },
      
  ],[]);
  const [showAddLicense, setShowAddLicense] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [iuccess, SetIsSuccess] = useState(false);
  const [tMessage, SetTMessage] = useState(false);
  const [krRowData, setKrRowData] = useState(null);
  const [krId, setKrId] = useState('');
    const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  const initialDelete=(deletedId:any)=>{
    let deleteBody={
      deletedId:deletedId,
      tenantId:tenantId
    }
    deleteTeam(deleteBody)
}

useEffect(() => {
  if (deleteData) {
    if (deleteData?.data.isSuccess) {
      setShowToastMessage2(true);
      SetIsSuccess(true);
      SetTMessage(deleteData?.data.metaData.message);
    } else {
      setShowToastMessage2(true);
      SetIsSuccess(false);
      SetTMessage(deleteData?.data.metaData.message);
    }
  }
}, [deleteData]);

  const renderContent=()=>{
    if (dataLoading) {
      return (<Box  width={'100%'} py={16}   >
        <CircularProgress   />
      </Box>)
    }
    else if(appStatusCode === 7){
      return (<Box  width={'100%'} py={16}   >
         <Typography variant='body1' textAlign={'center'} fontSize={'20px'} fontWeight={700}>
         شما دسترسی به این قسمت را ندارید و باید لایسنس خود را ارتقا دهید
    </Typography>
      </Box>)
    }
    else {
      return <>
       <DyDataGridCustom
     rowHeight={10}
     data={dataError || dataLoading ? []:dataIndex }
     columns={tenantsColumns || []}
     hideFooter={false}
     additionalToolbar={false}
     setSelectionModel={setIndexSelectionModel}
     setShowHistory={setHistoryModal}
     setSpecialId={()=>{}}
     initialOnRowClick={setKrRowData}
    //  initialDelete={initialDelete}
     /></>
    }
  }
  const initialAddLicense = (): void => {
    setShowAddLicense((prev) => !prev);
  };

  return (
    <>
    <Grid  sx={{bgcolor:'#F9F9F9',width:'100% !important',padding:'0px !important'}}   >
     <Grid item xs={12}   >
     <div>
      <Box py={1} display={'flex'} justifyContent={'end'}>
          <button
            onClick={(e: React.MouseEvent<HTMLElement>) =>
              initialAddLicense()
            }
            disabled ={!check?.check}
            className={`btn px-4  text-xs font-thin text-white bg-[#00387c]
               btn-sm rounded-md m-2`}
          >
            ثبت درخواست
          </button>
     </Box>
          <ModalLyt
            showModal={showAddLicense}
            setShowModal={setShowAddLicense}
            width={isMobile ? '350px' : '600px'} 
            height={500}
            title={"ثبت درخواست"}
          >
            <AddCooperateRequest
              onSuccess={setShowAddLicense}
              setShowToastMessage={setShowToastMessage}
              onClose={setShowAddLicense}
              teamIdd={teamId}
              periodId={periodId}
              keyResultId={keyResultId}
            />
          </ModalLyt>
     </div>
     </Grid>
     <Grid item xs={12}   >
     <Box textAlign={'center'}  mx={1} borderRadius={2} boxShadow={2} bgcolor={'white'} my={1} py={dataLoading?8:3}   >
    {
      renderContent()
    }
     </Box>
     {historyModal && (
          <ModalLyt
            title={"ویرایش"}
            showModal={Boolean(historyModal)}
            setShowModal={setHistoryModal}
          >
            <EditCooperateRequest
              krDetail={krRowData}
              setShowToastMessage = {setShowToastMessage}
              onClose={setHistoryModal}
              teamIdd={teamId}
              copId={krId}
              periodId={periodId}
              keyResultId={keyResultId}
            />
          </ModalLyt>
      )}
     </Grid>
     {showToastMessage && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
        {showToastMessage2 && (
          <DYToastMessage
            isSuccess={iuccess}
            message={tMessage}
            setShow={setShowToastMessage2}
            show={showToastMessage2}
          />
        )}
    </Grid>
    </>
  )
}

export default CooperateRequest
